import { inject } from '@angular/core';
import type { CanDeactivateFn } from '@angular/router';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfirmationDialogService } from '../../services/confirmation-dialog.service';

/**
 * Type for components that can prevent navigation when they have unsaved changes
 */
export type ComponentCanDeactivate = {
  canDeactivate: () => boolean | Observable<boolean>;
  getDirtyCount?: () => number;
};

/**
 * Guard that prompts the user to confirm navigation when there are unsaved changes
 */
export const unsavedChangesGuard: CanDeactivateFn<ComponentCanDeactivate> = (component: ComponentCanDeactivate) => {
  const confirmationService = inject(ConfirmationDialogService);

  if (component.canDeactivate && !component.canDeactivate()) {
    const dirtyCount = component.getDirtyCount ? component.getDirtyCount() : 1;

    return confirmationService.confirmUnsavedChanges(dirtyCount).pipe(
      map(result => {
        if (result === 'confirm') {
          return false;
        } else if (result === 'discard') {
          return true;
        } else {
          return false;
        }
      })
    );
  }

  return true;
};
